import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const TaskFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  onSearch 
}) => {
  const projectOptions = [
    { value: 'all', label: 'All Projects' },
    { value: 'website-redesign', label: 'Website Redesign' },
    { value: 'mobile-app', label: 'Mobile App Development' },
    { value: 'data-migration', label: 'Data Migration' },
    { value: 'security-audit', label: 'Security Audit' },
    { value: 'inventory-system', label: 'Inventory System' }
  ];

  const priorityOptions = [
    { value: 'all', label: 'All Priorities' },
    { value: 'high', label: 'High Priority' },
    { value: 'medium', label: 'Medium Priority' },
    { value: 'low', label: 'Low Priority' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'pending', label: 'Pending' },
    { value: 'in progress', label: 'In Progress' },
    { value: 'completed', label: 'Completed' },
    { value: 'overdue', label: 'Overdue' }
  ];

  const dueDateOptions = [
    { value: 'all', label: 'All Due Dates' },
    { value: 'today', label: 'Due Today' },
    { value: 'this-week', label: 'Due This Week' },
    { value: 'next-week', label: 'Due Next Week' },
    { value: 'overdue', label: 'Overdue' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 card-shadow mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Filter Tasks</h3>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          onClick={onClearFilters}
        >
          Clear All
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <Select
          label="Project"
          options={projectOptions}
          value={filters?.project}
          onChange={(value) => onFilterChange('project', value)}
          className="w-full"
        />

        <Select
          label="Priority"
          options={priorityOptions}
          value={filters?.priority}
          onChange={(value) => onFilterChange('priority', value)}
          className="w-full"
        />

        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
          className="w-full"
        />

        <Select
          label="Due Date"
          options={dueDateOptions}
          value={filters?.dueDate}
          onChange={(value) => onFilterChange('dueDate', value)}
          className="w-full"
        />
      </div>
      <div className="flex items-center space-x-4">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search tasks by title, description, or project..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
            className="w-full"
          />
        </div>
        <Button
          variant="default"
          iconName="Search"
          onClick={onSearch}
        >
          Search
        </Button>
      </div>
    </div>
  );
};

export default TaskFilters;